const defaultSuggestions = {
    eliminated: [
        `This design is off brief.`,
        `This design isn’t up to my creative standards.`,
        `I don't like this direction. Thanks for your time.`,
    ],
    unrated: [
        `This doesn't fit my style. Please check the brief.`,
        `I'm not sure about this design. Can you explain your thoughts behind it?`,
        `I like this idea, could you try…`,
        `I don't like this direction. Thanks for your time.`,
    ],
    '1': [
        `This is a good start, but I don't like…`,
        `This style doesn't fit my brand. Please check the brief.`,
        `I don't like this direction, can you try…`,
    ],
    '2': [
        `This is headed in the right direction. Can you improve the…`,
        `I like the style but can you change…`,
        `The layout isn't working because… `,
    ],
    '3': [
        `Good design, however I'd like to see…`,
        `I like this design, but I'd like to simplify…`,
        `I'd like to change the color scheme to…`,
    ],
    '4': [
        `Great design. Can you make revisions on…`,
        `This is really close. Can you show more color schemes like…`,
        `Can we change a couple of design elements like…`,
    ],
    '5': [
        `Excellent design. Can you make tweaks to the…`,
        `You're one of my favorites. Can I see this design with…`,
        `This is perfect. I'll get back to you if I need anything else.`,
    ],
};

const finalRoundSuggestions = {
    unrated: [
        `Can you change…`,
        `I'd like to focus on…`,
        `I don't like this direction. Thanks for your time.`,
        `Can you explain your thoughts behind this one?`,
    ],
    '1': [
        `This is looking ok, but overall I don't like…`,
        `This style doesn't fit my brand. Please update…`,
        `I don't like this direction, can you try…`,
    ],
};

export function suggestionsForDesign(design, { stage }) {
    const suggestions =
        stage == 'final-round'
            ? { ...defaultSuggestions, ...finalRoundSuggestions }
            : defaultSuggestions;

    if (design.isEliminated) {
        return suggestions['eliminated'];
    } else if (design.rating > 0) {
        return suggestions[String(design.rating)];
    } else {
        return suggestions['unrated'];
    }
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/rating-suggestion-text.js